import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private langSubject = new BehaviorSubject<string>(
    localStorage.getItem('appLanguage') || 'en',
  );

  lang$ = this.langSubject.asObservable();

  setLanguage(lang: string) {
    localStorage.setItem('appLanguage', lang);
    const dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.setAttribute('dir', dir);
    document.documentElement.setAttribute('lang', lang);
    document.body.setAttribute('dir', dir);
    this.langSubject.next(lang);
  }

  get currentLang() {
    return this.langSubject.getValue();
  }
}
